// extracted by mini-css-extract-plugin
export default {"searchbarGeneralContainer":"searchbar_searchbarGeneralContainer__VAZwO","searchbarContainer":"searchbar_searchbarContainer__88fJX","productsBox":"searchbar_productsBox__IWKW3"};